import { render, staticRenderFns } from "./ChatType.vue?vue&type=template&id=22a56c25&scoped=true&"
import script from "./ChatType.vue?vue&type=script&lang=js&"
export * from "./ChatType.vue?vue&type=script&lang=js&"
import style0 from "./ChatType.vue?vue&type=style&index=0&id=22a56c25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a56c25",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22a56c25')) {
      api.createRecord('22a56c25', component.options)
    } else {
      api.reload('22a56c25', component.options)
    }
    module.hot.accept("./ChatType.vue?vue&type=template&id=22a56c25&scoped=true&", function () {
      api.rerender('22a56c25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chat/components/newChat/ChatType.vue"
export default component.exports